export default {
  methods: {
    search (val) {
      let string = ''
      this.searchDlogArr = []
      if (!val) return;
      let arr = []
      this.chatlist.forEach((i, index) => {
        if (this.regex(i.innertext)) return;
        if (i.innertext.includes(val)) {
          arr.push({
            index: index,
            i: i
          })
        }
      })
      this.searchDlogArr = arr
      this.$emit("update:searchWord", val)
    },

    regex (string) {
      let status = false
      let standard = /^http\:\/\/imgsoure\.local\.host/;
      let standard1 = /^https\:\/\/pic\.gc16688\.com/
      if (standard.test(string) || standard1.test(string)) status = true
      return status
    },
    replace (text) {
      let replaceString = '<span class="searchText">' + this.searchtext + '</span>';
      return text.replace(this.searchtext, replaceString)
    },
    keyup () {
      setTimeout(() => { this.search(this.searchtext) }, 500)
    }
  }
}